import { useCompanies } from "contexts/companies/hooks/use-companies"
import { IPolicyholder } from "platform-client/types"

export interface IUseCompaniesMapResult {
  companiesMap: Map<string, string> | undefined
  isLoading: boolean
}

export const useCompaniesMap = (
  policyholders: IPolicyholder[] | undefined
): IUseCompaniesMapResult => {
  const { companiesMap, isLoading } = useCompanies()

  return {
    companiesMap,
    isLoading
  }
}
